import Vue from "vue";
import i18n from "@/util/language";
import "babel-polyfill";

import App from "@/App";
import "@/router";
import store from "@/store";
import "@/style/main.scss";

import "@/icons";
import "@/permission";

import * as filters from "@/filters"; //全局的过滤器
// 注册所有的全局过滤器
Object.keys(filters).forEach((key) => {
	Vue.filter(key, filters[key]);
});

import * as directives from "@/directives"; //全局的指令
// 全局注册所有指令
Object.keys(directives).forEach((key) => {
	Vue.directive(key, directives[key]);
});

import "@/plugins";

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
	el: "#app",
	router,
	store,
	i18n,
	components: { App },
	template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js